module.exports = __webpack_public_path__ + "static/media/8.93f5d39d.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/rhand/8.png
// module id = 964
// module chunks = 0